import { ReactComponent as Logo } from '../../images/TellyLogo.svg'
import { parse } from 'query-string'
import { useEffect, useRef, useState } from 'react'
import {
  Container,
  Wrapper,
  Header,
  Title,
  LogoContainer,
  Main,
  Message,
  Text,
  RightBackground,
  Footer,
  GoToTellyApp,
} from '../MobileApp/MobileApp.styles'
import { getAppStoreFallbackUrl } from 'constants/appStores'
import { getTellyPhoneMobileURI } from 'constants/mobile'
import { Actions } from './TellyPhone.styles'

const STORE_FALLBACK_DELAY_MS = 4000

export const TellyPhone: React.FC = (): JSX.Element => {
  const [code, setCode] = useState('')
  const anchorRef = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    const { c } = parse(location.search)
    if (typeof c === 'string') {
      setCode(c)
    }

    const clickTimer = setTimeout(() => {
      anchorRef.current?.click()
    }, 200)

    const storeTimer = setTimeout(() => {
      location.href = getAppStoreFallbackUrl(navigator.userAgent)
    }, STORE_FALLBACK_DELAY_MS)

    // Cancel the store redirect if TMA opened and backgrounded the browser.
    const onVisibilityChange = (): void => {
      if (document.hidden) {
        clearTimeout(storeTimer)
      }
    }
    document.addEventListener('visibilitychange', onVisibilityChange)

    return (): void => {
      clearTimeout(clickTimer)
      clearTimeout(storeTimer)
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])

  return (
    <Wrapper>
      <Header>
        <LogoContainer>
          <Logo />
        </LogoContainer>
      </Header>

      <Main>
        <Container>
          <Title>almost there!</Title>
          <Message>Please open this invite on your mobile phone.</Message>
          <Text>
            If the Telly mobile app doesn&apos;t open automatically, we&apos;ll
            redirect you to the app store to install it.
          </Text>
          <Actions>
            {code && (
              <GoToTellyApp ref={anchorRef} href={getTellyPhoneMobileURI(code)}>
                Go to Telly Mobile App
              </GoToTellyApp>
            )}
            <GoToTellyApp href={getAppStoreFallbackUrl(navigator.userAgent)}>
              Download the App
            </GoToTellyApp>
          </Actions>
        </Container>
        <RightBackground />
      </Main>
      <Footer />
    </Wrapper>
  )
}
